/**
 * La ruta principal de la web. Este componente sirve como router al resto de páginas de la web.
 * Las rutas están protegidas para que no se pueda acceder si no se está loggeado.
**/

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./db/AuthContext";
import ProtectedRoute from "./db/ProtectedRoute";
import Login from "./components/Login";
import Principal from "./components/Principal";
import Register from "./components/Register";
import Pricing from "./components/Pricing";
import Files from "./components/File";

//Se ha ocultado la ruta a la página de registro de momento

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<ProtectedRoute><Principal /></ProtectedRoute>} />
          {/* <Route path="/register" element={<Register />} /> */}
          <Route path="/pricing" element={<ProtectedRoute><Pricing /></ProtectedRoute>} />
          <Route path="/files" element={<ProtectedRoute><Files /></ProtectedRoute>} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
